(function($, window, document, PageLoadedQueue) {
    window.PageLoadedQueue.addFunction(function() {
        if ($.prototype.slick) {
            const selector = $('.avency-avency-services-content-slider');

            if(selector.length) {
                selector.each(function() {
                    const sliderId = '#' + $(this).prop('id');
                    const slider = $(sliderId + ' .slider__items');

                    slider.slick();
                });
            }
        }
    });
})(jQuery, window, document, window.PageLoadedQueue);
